module.exports = __webpack_public_path__ + "img/passport@2x.18ee962a.png";